import React from 'react'
import { Dispute, Downtime, Promotions, Reviews } from '../../view/FinanceReco'

const FeaturesSlider = () => {
  return (
    <div className='s3-fin-reco f-width m-auto'>
        <div className='fin-s3-features'>
            <p className='fs-md'>Explore Other Powerful Voosh Features</p>
            <div className='slider-wrap'>
                <div className='img-col'>
                    <div className='img-track'>
                        <img src={Promotions} alt='Voosh promotion manager' />
                        <img src={Downtime} alt='Voosh downtime controller' />
                        <img src={Reviews} alt='Voosh Reviews and Rating' />
                        <img src={Dispute} alt='Voosh dispute manager' />

                        <img src={Promotions} alt='Voosh promotion manager' />
                        <img src={Downtime} alt='Voosh downtime controller' />
                        <img src={Reviews} alt='Voosh Reviews and Rating' />
                        <img src={Dispute} alt='Voosh dispute manager' />
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default FeaturesSlider